import React, { useState, useEffect, useRef } from 'react'
import Image from 'next/image'

interface KanaStrokeAnimationProps {
  kana: string
  type: 'hiragana' | 'katakana'
  className?: string
}

export const KanaStrokeAnimation: React.FC<KanaStrokeAnimationProps> = ({ 
  kana, 
  type, 
  className = '' 
}) => {
  const [gifPath, setGifPath] = useState<string | null>(null)
  const [loadError, setLoadError] = useState<boolean>(false)

  useEffect(() => {
    // 構建 GIF 路徑
    const gifPath = `/kana-strokes/50/${type}/GIF/${type === 'hiragana' ? 'Hiragana' : 'Katakana'}_${kana}_stroke_order_animation.gif`
    setGifPath(gifPath)
    setLoadError(false)
  }, [kana, type])

  const handleImageError = () => {
    // GIF 載入失敗時，不顯示動畫（降級方案：靜態顯示假名）
    setLoadError(true)
    setGifPath(null)
  }

  // 如果載入失敗或沒有 GIF，不渲染任何東西（降級方案：不顯示動畫）
  if (loadError || !gifPath) {
    return null
  }

  return (
    <Image 
      src={gifPath} 
      alt={`${kana} 筆順動畫`} 
      className={`kana-stroke-animation ${className || 'w-64 h-64'}`}
      onError={handleImageError}
      width={256}
      height={256}
      unoptimized
    />
  )
}
